export const MAIN_HEADER_HEIGHT_PX = 60;

//  rec page
export const REC_BUTTON_WIDTH_PX = 240;
export const REC_BUTTON_HEIGHT_PX = 60;

// inbox
export const INBOX_WIDTH_PX = 320;
export const INBOX_WIDTH_PX_MIN = 260;
export const INBOX_WIDTH_PX_MAX = 420;

// donor sidebar
export const DONOR_SIDEBAR_WIDTH_PX = 420;

export const content = {
  targetable: {
    contextFromMgo: "General catchup",
  },
  sentry: {
    feedbackWidgetTitle: "Report an issue",
  },
};
